<template>
    <!-- <div v-if="show" class="modal fade show bg-dark bg-opacity-75 border-radius-01" tabindex="-1" aria-hidden="true" aria-labelledby="modalTitle" aria-modal="false" role="dialog" style="display: block;"> -->
    <div :id="id" class="modal fade show1 bg-dark bg-opacity-75 border-radius-01" tabindex="-1" aria-hidden="true" aria-labelledby="modalTitle" aria-modal="false" role="dialog">
        <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable rounded">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5 w-100 text-center" id="modalTitle" v-html="data?.title"></h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
                </div>
                <div class="modal-body" v-html="data?.content"></div>
                <!-- <div class="modal-footer">
                    <button class="btn btn-outline-secondary" @click="show = false">{{ data?.btn }}</button>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import { ref } from "vue";

    export default {
        name: "ScrollableC",
        props: {
            id:{
                type: String,
                default: () => "modal"
            },
            data:{
                type: Object,
                default: () => {}
            }
        },
        setup(props) {
            const show = ref();
            return { show };
        },
    };
</script>


<style lang="scss">
// :root{
//     --bs-border-radius-lg: 0;
// }
</style>